// extracted by mini-css-extract-plugin
export default {"page":"styles_page__qlikC","refreshNotice":"styles_refreshNotice__goUN4"};